import {useState, useEffect} from 'react';
import Chip from '@mui/material/Chip';
import Avatar from '@mui/material/Avatar';
import ErrorHandler from '@Root/ErrorHandler';
import Collapsible from 'react-collapsible';
import BoxOptions from '@CommonFunctionalDisplay/BoxOptions';
import FormAgentView from '@IssueConsoleViews/FormAgentView';
import DeleteFormAgentForm from '@IssueConsoleForms/DeleteFormAgentForm';
import UserInfoService from '@Helpers/URLHelpers/UserInfoService';
import { IoChevronForwardOutline as PathArrow } from 'react-icons/io5';
import { MdEmail as Email } from 'react-icons/md';
import { FaWhatsapp as WhatsApp } from 'react-icons/fa';
import { MdNotifications as Notifications } from 'react-icons/md';
import { useReduxProject } from '@Hooks/reduxProjectHook/useReduxProject';
import '@Partials/_ComStyles.scss';
import '@Partials/_SimpleStyles.scss';
import './FormAgentCard.scss';

export default function FormAgentCard(props) {

    const [hovered, setHovered] = useState(false);
    const [kaiziqResolveConnection] = useState({})
    const [details, setDetails] = useState({})
    const [showFormAgentView, setShowFormAgentView] = useState(false);
    const [showDeleteFormAgentForm, setShowDeleteFormAgentForm] = useState(false);
    const [formAgentUser, setFormAgentUser] = useState({})
    const [collapsibleOpen, setCollapsibleOpen] = useState(false);
    const errorHandler = new ErrorHandler();
    const userInfoService = new UserInfoService();
    const { currentUserProjectPermissions } = useReduxProject();
    const className = 'formAgentCard';
    const colorList = ['#2784B9', '#40c47d', '#FDB16C', '#b06060', '#f77474', '#6080b0', '#9a60b0', '#6cb060',
        '#b0ae60', '#65412b', '#cc9963', '#e1bd83', '#60748b', '#744700', '#c8d579', '#5f8fba', '#3e6073', '#8e6dc1'];

    useEffect(() => {
        renderData();
    }, [props]);

    const renderData = async() => {
        await renderUserData();
        setDetails(JSON.parse(props.formAgent?.details));
    }

    const renderUserData = async() => {
        var loadLoops = 0, loadingError = false, errorException;
        let user;
        for(loadLoops = 0; loadLoops < 10; loadLoops++) {
            try {
                user = await userInfoService.getUserById(props.formAgent?.userId);
                user = JSON.parse(user.body);
                setFormAgentUser(user);
                loadingError = false;
                break;
            } catch (err) {
                errorHandler.logError('User Data', err);
                loadingError = true;
                errorException = err;
            }
        }
        if(loadLoops === 10 && loadingError === true) {
            errorHandler.handleError(errorException);
            return false;
        }
        return true;
    }

    const getInitials = (name) => {
        if (!name) return 'NA';
        const names = name.split(' ');
        if (names.length >= 2) {
            return names[0][0] + names[names.length - 1][0];
        }
        return names[0][0];
    };

    const dataURLtoFile = (dataurl) => {
        var arr = dataurl.split(','),
            mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]),
            n = bstr.length,
            u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new File([u8arr], { type: mime });
    };

    const toggleShowFormAgentView = () => {
        setShowFormAgentView(!showFormAgentView);
    }

    const toggleShowDeleteFormAgentForm = () => {
        setShowDeleteFormAgentForm(!showDeleteFormAgentForm);
    }

    const toggleCollapsibleOpen = () => {
        if(collapsibleOpen) {
            document.getElementById('arrow__FA' + props.formAgent?.id).style.transform = 'rotate(0)'
        } else {
            document.getElementById('arrow__FA' + props.formAgent?.id).style.transform = 'rotate(90deg)';
        }
        setCollapsibleOpen(!collapsibleOpen);
    }

    const hasNotifications = (details?.settings?.create?.email || details?.settings?.create?.whatsapp ||
        details?.settings?.update?.email || details?.settings?.update?.whatsapp ||
        details?.settings?.resolve?.email || details?.settings?.resolve?.whatsapp ||
        details?.settings?.escalate?.email || details?.settings?.escalate?.whatsapp);

    return (
        <div className={`${className} ${hovered ? 'hovered' : ''}`}
            onMouseEnter={() => setHovered(true)}
            onMouseLeave={() => setHovered(false)}>
            <div className={`${className}__card`}>
                {/* Header */}
                <div className={`${className}__header`}>
                    <div className={`${className}__header__user`}>
                        {formAgentUser?.photo ? (
                            <img 
                                src={URL.createObjectURL(dataURLtoFile(formAgentUser.photo))}
                                className={`${className}__header__user__avatar`}
                                alt='profile'
                            />
                        ) : (
                            <Avatar 
                                className={`${className}__header__user__avatar`}
                                sx={{ 
                                    bgcolor: colorList[formAgentUser?.fullName?.charCodeAt(0) % colorList?.length] + ' !important',
                                    width: 48,
                                    height: 48
                                }}
                            >
                                {getInitials(formAgentUser?.fullName)}
                            </Avatar>
                        )}
                        <div className={`${className}__header__user__info`}>
                            <div className={`${className}__header__user__name`}>
                                {formAgentUser.fullName}
                            </div>
                            <div className={`${className}__header__user__username`}>
                                @{formAgentUser.userName}
                            </div>
                        </div>
                    </div>
                    <div className={`${className}__header__actions`}>
                        <button 
                            className={`${className}__header__expandBtn`}
                            onClick={toggleCollapsibleOpen}
                        >
                            <PathArrow 
                                className={`${className}__header__expandBtn__icon`}
                                id={'arrow__FA' + props.formAgent?.id}
                            />
                        </button>
                        <BoxOptions
                            hovered={hovered}
                            showDelete={currentUserProjectPermissions?.allowCreate}
                            handleViewClickCallback={toggleShowFormAgentView}
                            handleDeleteClickCallback={toggleShowDeleteFormAgentForm}
                        />
                    </div>
                </div>

                {/* Quick Info */}
                {hasNotifications && (
                    <div className={`${className}__quickInfo`}>
                        <Notifications className={`${className}__quickInfo__icon`} />
                        <span className={`${className}__quickInfo__text`}>
                            Receives notifications
                        </span>
                    </div>
                )}

                {/* Expandable Content */}
                <Collapsible
                    open={collapsibleOpen}
                    transitionTime={200}
                    triggerDisabled={true}
                    classParentString={`${className}__collapsible`}
                >
                    {collapsibleOpen && (
                        <div className={`${className}__details`}>
                            <div className={`${className}__details__title`}>
                                <Notifications className={`${className}__details__title__icon`} />
                                Notification Settings
                            </div>

                            {(details?.settings?.create?.email || details?.settings?.create?.whatsapp) && (
                                <div className={`${className}__details__item`}>
                                    <div className={`${className}__details__item__left`}>
                                        <span className={`${className}__details__item__label`}>Ticket Created</span>
                                        <span className={`${className}__details__item__hint`}>When new tickets are submitted</span>
                                    </div>
                                    <div className={`${className}__details__item__right`}>
                                        {details?.settings?.create?.email && (
                                            <Chip
                                                icon={<Email />}
                                                label="Email"
                                                size="small"
                                                color="primary"
                                                variant="outlined"
                                            />
                                        )}
                                        {details?.settings?.create?.whatsapp && (
                                            <Chip
                                                icon={<WhatsApp />}
                                                label="WhatsApp"
                                                size="small"
                                                color="success"
                                                variant="outlined"
                                            />
                                        )}
                                    </div>
                                </div>
                            )}

                            {(details?.settings?.update?.email || details?.settings?.update?.whatsapp) && (
                                <div className={`${className}__details__item`}>
                                    <div className={`${className}__details__item__left`}>
                                        <span className={`${className}__details__item__label`}>Ticket Updated</span>
                                        <span className={`${className}__details__item__hint`}>When tickets are modified</span>
                                    </div>
                                    <div className={`${className}__details__item__right`}>
                                        {details?.settings?.update?.email && (
                                            <Chip
                                                icon={<Email />}
                                                label="Email"
                                                size="small"
                                                color="primary"
                                                variant="outlined"
                                            />
                                        )}
                                        {details?.settings?.update?.whatsapp && (
                                            <Chip
                                                icon={<WhatsApp />}
                                                label="WhatsApp"
                                                size="small"
                                                color="success"
                                                variant="outlined"
                                            />
                                        )}
                                    </div>
                                </div>
                            )}

                            {(details?.settings?.resolve?.email || details?.settings?.resolve?.whatsapp) && (
                                <div className={`${className}__details__item`}>
                                    <div className={`${className}__details__item__left`}>
                                        <span className={`${className}__details__item__label`}>Ticket Resolved</span>
                                        <span className={`${className}__details__item__hint`}>When tickets are closed</span>
                                    </div>
                                    <div className={`${className}__details__item__right`}>
                                        {details?.settings?.resolve?.email && (
                                            <Chip
                                                icon={<Email />}
                                                label="Email"
                                                size="small"
                                                color="primary"
                                                variant="outlined"
                                            />
                                        )}
                                        {details?.settings?.resolve?.whatsapp && (
                                            <Chip
                                                icon={<WhatsApp />}
                                                label="WhatsApp"
                                                size="small"
                                                color="success"
                                                variant="outlined"
                                            />
                                        )}
                                    </div>
                                </div>
                            )}

                            {(details?.settings?.escalate?.email || details?.settings?.escalate?.whatsapp) && (
                                <div className={`${className}__details__item`}>
                                    <div className={`${className}__details__item__left`}>
                                        <span className={`${className}__details__item__label`}>Ticket Escalated</span>
                                        <span className={`${className}__details__item__hint`}>When tickets need attention</span>
                                    </div>
                                    <div className={`${className}__details__item__right`}>
                                        {details?.settings?.escalate?.email && (
                                            <Chip
                                                icon={<Email />}
                                                label="Email"
                                                size="small"
                                                color="primary"
                                                variant="outlined"
                                            />
                                        )}
                                        {details?.settings?.escalate?.whatsapp && (
                                            <Chip
                                                icon={<WhatsApp />}
                                                label="WhatsApp"
                                                size="small"
                                                color="success"
                                                variant="outlined"
                                            />
                                        )}
                                    </div>
                                </div>
                            )}

                            {!hasNotifications && (
                                <div className={`${className}__details__empty`}>
                                    <Notifications className={`${className}__details__empty__icon`} />
                                    <span className={`${className}__details__empty__text`}>
                                        No notifications configured
                                    </span>
                                </div>
                            )}
                        </div>
                    )}
                </Collapsible>
            </div>

            {showFormAgentView && (
                <FormAgentView
                    open={showFormAgentView}
                    closePopup={toggleShowFormAgentView}
                    kaiziqResolveConnection={kaiziqResolveConnection}
                    formAgent={props.formAgent}
                    details={details}
                    reloadData={props.reloadData}
                />
            )}
            {showDeleteFormAgentForm && (
                <DeleteFormAgentForm
                    open={showDeleteFormAgentForm}
                    closePopup={toggleShowDeleteFormAgentForm}
                    formAgent={props.formAgent}
                    reloadData={props.reloadData}
                />
            )}
        </div>
    );
}
